import api from './api-config';

// Update the getTransactions function in api.js to properly handle the structured response
export const getTransactions = async (params = {}) => {
    try {
        // Format params to match API expectations
        const apiParams = {...params};

        // Convert frontend pagination params to backend pagination params if needed
        if (params.skip !== undefined || params.limit !== undefined) {
            apiParams.skip = params.skip || 0;
            apiParams.limit = params.limit || 100;
        }

        // Convert tag IDs to proper format for API if needed
        if (params.tagIds && params.tagIds.length > 0) {
            apiParams.tag_ids = params.tagIds;
            delete apiParams.tagIds; // Remove the original property to avoid duplication
        }

        // Remove empty/null/undefined values to prevent API errors
        Object.keys(apiParams).forEach(key => {
            if (apiParams[key] === '' || apiParams[key] === null || apiParams[key] === undefined) {
                delete apiParams[key];
            }
        });

        const response = await api.get('/transactions', {params: apiParams});

        // Return the full structured response which contains results and metadata
        return response.data;
    } catch (error) {
        console.error('Error fetching transactions:', error);
        throw error;
    }
};


// New function to find similar transactions
export const findSimilarTransactions = async (params = {}) => {
    try {
        const response = await api.get('/transactions/find-similar', {params});
        return response.data;
    } catch (error) {
        console.error('Error finding similar transactions:', error);
        throw error;
    }
};

export const getUntaggedTransactionCount = async () => {
    try {
        const response = await api.get('/transactions/untagged-count', {});
        return response.data;
    } catch (error) {
        console.error('Error:', error);
        throw error;
    }
};

// Get detailed transaction information
export const getTransactionDetails = async (transactionId) => {
    try {
        const response = await api.get(`/transactions/${transactionId}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching transaction details:', error);
        throw error;
    }
};

